export default __webpack_public_path__ + "static/media/account-transparent.282c1ca7.svg";